/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PatchCurrentContractInvestmentBodyInvestmentToolType =
  (typeof PatchCurrentContractInvestmentBodyInvestmentToolType)[keyof typeof PatchCurrentContractInvestmentBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchCurrentContractInvestmentBodyInvestmentToolType = {
  investment: "investment",
} as const;
